import { combineReducers } from 'redux';

const defaultIncomingCalls = {};
const selectedTabCalls = (state = defaultIncomingCalls, action) => {
  switch (action.type) {
    case 'CALLS_FILTER_SUCCESS':
      return action.callsFilter;
    default:
      return state;
  }
};

const callCount = {};
const getCallsCount = (state = callCount, action) => {
  switch (action.type) {
    case 'CALLS_COUNT_SUCCESS':
      return action.callsCount;
    default:
      return state;
  }
}

export default combineReducers({
  selectedTabCalls,
  getCallsCount
});
